import React from "react";
import { Tree, Breadcrumb, Button, Icon, Modal, Upload, message, Progress, Tooltip } from "antd";
import { connect } from 'react-redux';
import { VIDEO_TYPE, ATTCHMENT_TYPE, PIC_TYPE,AUDIO_TYPE } from "../../../constants/index";
import UploadWall from "../../../components/upload/UploadWallPackage";
import { checkFileStatus } from "../../../actions/upload";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import ChunkUploadPackage from "../../../components/upload/ChunkUploadPackage";
import * as Actions from "../../../actions/taskUpload";
import _ from 'lodash';
import PropTypes from "prop-types";
import "./taskUpload.scss";
import Scrollbars from "react-custom-scrollbars";
import UploadWallPackage from "../../../components/upload/UploadWallPackage";
import  * as utils from'../../../utils/index'
import {applicationName} from "../../../utils";
const { TreeNode } = Tree;
const { confirm } = Modal;
const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
const headerJson = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json;charset=UTF-8',
};
let isIE=utils.isIE();
class TaskUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            treeData: [],  //目录树树形结构
            breadCrumb: [], //面包屑list
            fileList: [],   //文件资源list
            accept: '', //upload接受的文件类型
            taskId: this.props.taskId,   //任务id
            menuId: 0,  //菜单id
            fileType: this.props.fileType, //文件类型  2--图片 3--视频 4--文件
            expandedKeys: [], //展开指定的树节点 id
            selectedKeys: [], //当前选中的节点 id
            previewVisible: false,
            previewImage: '',
            progress: 0,
            uploadText: '',
            folderList: [],
            zipProgress: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.taskId !== this.props.taskId || nextProps.data !== this.props.data || nextProps.fileType !== this.props.fileType) {
            this.setState({
                taskId: nextProps.taskId,
                fileType: nextProps.fileType,
                treeData: [],
                breadCrumb: [], //面包屑list
                fileList: [],   //文件资源list
                accept: '', //upload接受的文件类型
                menuId: 0,  //菜单id
                expandedKeys: [], //展开指定的树节点 id
                selectedKeys: [], //当前选中的节点 id
                uploadText: '',
                folderList: [],
                zipProgress: ''
            }, () => {
                this.initData('init');
            })
        }
    }

    componentDidMount() {
        this.initData('init');
    }

    initData = (type) => {
        //页面初始化时请求数据  获取文件夹和文件list 初始化 fileList
        Actions.getTreeData({ taskId: this.state.taskId, type: this.state.fileType }, (data) => {
            let menuId = 0;
            let treeData = [];
            let expendKeys = [];
            treeData = data;
            menuId = type === 'init' ? data[0].id : this.state.menuId;
            console.log(this.state.expendKeys)
            if (Array.isArray(data) && Object.keys(data[0]) && data[0].id) {
                this.setState({
                    menuId,
                    treeData,
                }, () => {

                    let parentIds = this.getParentIds(treeData, menuId, this.state.expandedKeys);
                    expendKeys = type === 'init' ? [data[0].id.toString()] : _.uniq([...parentIds]);
                    console.log(menuId, expendKeys)
                    this.getResource();
                })
            }
            this.setState({

                expendKeys,
                selectedKeys: [menuId + ""]
            })
        })
        //根据fileType确定accept类型 
        this.getAcceptType();
    }

    //根据fileType确定accept类型
    getAcceptType = () => {
        const { fileType } = this.state;
        let accept = ''
        switch (fileType) {
            case 2: accept = "." + [...PIC_TYPE,].join(",."); break;
            case 3: accept = "." + [...VIDEO_TYPE].join(",."); break;
            case 4: accept = "." + [...PIC_TYPE, ...ATTCHMENT_TYPE,...VIDEO_TYPE,...AUDIO_TYPE].join(",."); break;
            default: break;
        }
        this.setState({
            accept
        })
    }

    //根据menuId查询资源信息
    getResource = () => {
        Actions.getResourceData({ taskMenuId: this.state.menuId, type: this.state.fileType }, (data) => {
            let fileList = [];
            if (data.menus && data.menus.length > 0) {
                data.menus.map((item) => {
                    if (item) {
                        fileList.push({
                            uid: parseInt(item.id) * -1,
                            name: item.name,
                            status: 'done',
                            type: 'folder',
                            isChunk: true,
                            id: item.id
                        })
                    }
                })
            }
            if (data.resources && data.resources.length > 0) {
                data.resources.map((item) => {
                    if(item){
                        fileList.push({
                            resourceId: item.resourceId,
                            uid: parseInt(item.id) * -1,
                            name: item.name,
                            status: 'done',
                            path: item.path,
                            url: item.path,
                            ext: item.ext,
                            type: this.state.fileType === 2 ? "picture" : this.state.fileType === 3 ? 'video' : 'attachment',
                            isChunk: false,
                            id: item.id,
                        })
                    }
                })
            }
            this.getBreadCrumb();
            this.setState({
                fileList
            })
        })
    }

    //查询面包屑数据
    getBreadCrumb = () => {
        Actions.getBreadCrumbData({ taskId: this.state.taskId, type: this.state.fileType, taskMenuId: this.state.menuId }, (data) => {
            let breadCrumb = [];
            breadCrumb = data;
            this.setState({
                breadCrumb
            })
        });
    }

    //双击文件夹事件
    clickFolder = (taskMenuId) => {
        let parentIds = this.getParentIds(this.state.treeData, taskMenuId, this.state.expendKeys);
        let expendKeys = _.uniq([...parentIds]);
        this.setState({
            menuId: taskMenuId,
            expendKeys,
            selectedKeys: [taskMenuId + ""],
            zipProgress: ''
        }, () => {
            this.getResource()
        })
    }

    //渲染左侧目录树
    renderTreeContent = (treeData) =>
        treeData.map((item) => {
            if (item.taskMenuList && item.taskMenuList.length) {
                return (
                    <TreeNode key={item.id} title={item.name}>
                        {this.renderTreeContent(item.taskMenuList)}
                    </TreeNode>
                )
            }
            return <TreeNode key={item.id} title={item.name}></TreeNode>
    })

    //点击目录树节点
    selectTreeNode = (keys, e) => {
        if (e.selected) {
            this.clickFolder(keys[0]);
            this.setState({
                selectedKeys: [e.node.props.eventKey]
            })
        }
    }

    //目录树展开收起
    changeExpend = (expendKeys) => {
        this.setState({
            expendKeys
        })
    }

    //根据节点id查询所有父节点的id的数组 treeData--数据源   menuId--节点id  parentIds--父节点id数组
    getParentIds = (treeData, menuId, parentIds) => {
        //1、需要先找到menuId对应的 parentId,
        let resourceData = this.state.treeData
        if (Array.isArray(treeData)) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].id === menuId) {
                    parentIds.push(treeData[i].id + "")
                    if (treeData[i].fid !== 0) {
                        this.getParentIds(resourceData, treeData[i].fid, parentIds);
                    } else {
                        return parentIds;
                    }
                } else {
                    if (treeData[i].taskMenuList) {
                        this.getParentIds(treeData[i].taskMenuList, menuId, parentIds)
                    }
                }
            }
        }
        return parentIds
    }

    //渲染上传组件
    renderUpload = () => {
        const { accept, fileType, progress, folderList, zipProgress } = this.state;
        console.log(zipProgress)
        const uploadText = {
            'uploading': '正在上传',
            'merging': '正在解压',
            'uploadDown': '正在解压',
            'compressComplete': '解压完成',
            'cancelUpload': '终止上传',
            'cancelCompression': '终止解压'
        };
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <>

                <div className="percent">
                    {
                        zipProgress === 'cancelUpload' || zipProgress === 'cancelCompression' ? uploadText[zipProgress] :
                            zipProgress === 'uploading' || zipProgress === 'uploadDown' || zipProgress === 'merging' ?
                                <>
                                    <span>{uploadText[zipProgress]}</span>
                                    <Progress className="upload-progress" strokeColor={newSecondSelectColor} trailColor="#f4f6fc" strokeLinecap="square" percent={progress} />
                                    {isIE?null:<div className="cancel" onClick={this.cancelUpload} style={{ border: `1px solid ${newSecondSelectColor}` }}><Tooltip title={`${zipProgress === 'uploading' ? '终止上传' : zipProgress === 'uploadDown' ? '终止解压' : ''}`}><Icon type="close" style={{ color: newSecondSelectColor }} /></Tooltip></div>}
                                </> : null

                    }
                </div>
                <div className="upload-button" style={{display: 'flex',justifyContent: 'flex-end'}}>
                    <Upload
                        accept={accept}
                        multiple={true}
                        fileList={this.state.fileList}
                        className="upload-content"
                        action="/cm-sites-pms/index/uploadFile"
                        onChange={fileType === 2 ? this.handleNotChunk : this.handleChunk}
                        customRequest={fileType !== 2 ? new ChunkUpload({
                            checkFileURL: "/cm-sites-" + applicationName() + "/index/checkFile",
                            checkChunkURL: "/cm-sites-" + applicationName() + "/index/checkChunk",
                            uploadChunkURL: "/cm-sites-" + applicationName() + "/index/uploadChunks",
                            chunkUploadOverURL: "/cm-sites-" + applicationName() + "/index/chunkUploadOver",
                            mergeChunksURL: "/cm-sites-" + applicationName() + "/index/mergeChunks"
                        }).start : null}
                    >
                        <Button type="primary" >
                            上传文件
                </Button>
                    </Upload>
                    {this.state.fileType != 4
                        ?(
                            <Upload
                                accept={".zip"}
                                method="post"
                                fileList={folderList}
                                className="upload-content"
                                action="/cm-sites-pms/index/uploadFile"
                                customRequest={new ChunkUploadPackage({
                                    checkFileURL: "/cm-sites-" + applicationName() + "/index/checkFile",
                                    checkChunkURL: "/cm-sites-" + applicationName() + "/index/checkChunk",
                                    uploadChunkURL: "/cm-sites-" + applicationName() + "/index/uploadChunks",
                                    chunkUploadOverURL: "/cm-sites-" + applicationName() + "/index/chunkUploadOver",
                                    mergeChunksURL: "/cm-sites-" + applicationName() + "/index/taskResourceMergeChunks"
                                }).start}
                                onChange={this.handleZipChange}
                                withCredentials
                                data={
                                    {
                                        taskId: this.state.taskId,
                                        type: this.state.fileType,
                                        taskMenuId: this.state.menuId
                                    }
                                }
                                beforeUpload={this.handleBeforeUploadZip}
                            >
                                <Button type="primary" className={zipProgress === 'uploading' || zipProgress === 'uploadDown' ? 'upload-botton-disabled' : ''} disabled={zipProgress === 'uploading' || zipProgress === 'uploadDown'?true:false}>
                                    上传压缩包
                                </Button>
                            </Upload>
                        )
                        :null}
                </div>


            </>
        )
    }

    //终止上传
    cancelUpload = () => {
        if(isIE){
            return
        }
        const { zipProgress, taskId } = this.state;
        if (zipProgress === 'uploading') {  //说明正在上传中
            clearTimeout(window.testCancel);
            if(!isIE){
                window.checkChunkAjax && window.checkChunkAjax.abort();
                window.uploadChunkAjax && window.uploadChunkAjax.abort();
                window.chunkUploadOverAjax && window.chunkUploadOverAjax.abort();
                window.mergeChunksAjax && window.mergeChunksAjax.abort();
            }
            this.setState({
                zipProgress: 'cancelUpload'
            })
        }
        if (zipProgress === 'merging') {
            window.cancelCheckStatus && clearTimeout(window.cancelCheckStatus)
        }
        if (zipProgress === 'uploadDown') {   //说明上传完成，正在解压中
            window.cancelGetResourceStatus && clearTimeout(window.cancelGetResourceStatus);
            if(!isIE){
                window.CompressopmController && window.CompressopmController.abort();
            }
            Actions.updateTaskMenuResourceStatus({ taskId }, (res) => {
                if (res) {
                    this.setState({
                        zipProgress: 'cancelCompression'
                    })
                }
            })
        };
    }

    //压缩包上传 检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatusZip(md5, ingCallBack, overCallBack) {
        window.cancelCheckStatus = setTimeout(() => {
            checkFileStatus(md5).then(res => {
                if (res.state !== "mergeComplete") {
                    this.checkStatusZip(md5, ingCallBack, overCallBack);
                    this.setState({
                        zipProgress: 'uploadDown'
                    })
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack();
            });
        }, 100);//每隔一秒钟进行检查一次
    }

    //压缩包上传
    handleZipChange = (info) => {
        let zipProgress = 'uploading'
        if (info.file.status === 'done') {
            info.file.percent = 100;
            if (info.file.response.status === 200 && info.file.response.data) {
                zipProgress = 'uploadDown';
                this.setState({
                    zipProgress: 'merging'
                }, () => {
                    this.checkStatusZip(info.file.response.data, () => { }, (data) => {
                        let params = {
                            url: data.storageFile.path,
                            resourceName: data.storageFile.name,
                            fileMd5: data.storageFile.md5,
                            taskId: this.state.taskId,
                            type: this.state.fileType,
                            taskMenuId: this.state.menuId
                        };

                        window.CompressopmController =!isIE?new AbortController():{};
                        const { signal } = window.CompressopmController;
                        let url = "/cm-sites-" + applicationName() + '/taskMenuResource/decompressionZip' + '?time=' + new Date().getTime();
                        fetch(url, {
                            method: 'post',
                            cache: 'no-cache',
                            body: JSON.stringify(params),
                            headers: headerJson,
                            credentials: 'include',
                            signal
                        }).then(response => response.json()).then(res => {
                            if (res.data) {
                                this.getTaskMenuResourceStatus()
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                    })
                })
            }
            if (info.file.response.success) {
                zipProgress = 'uploadDown';
                this.setState({
                    zipProgress: 'uploadDown'  //上传成功
                }, () => {
                    let params = {
                        url: info.file.response.storageFile.path,
                        resourceName: info.file.response.storageFile.name,
                        fileMd5: info.file.response.storageFile.md5,
                        taskId: this.state.taskId,
                        type: this.state.fileType,
                        taskMenuId: this.state.menuId
                    };
                    window.CompressopmController = !isIE?new AbortController():{};
                    const { signal } = window.CompressopmController;
                    let url = "/cm-sites-" + applicationName() + '/taskMenuResource/decompressionZip' + '?time=' + new Date().getTime();
                    fetch(url, {
                        method: 'post',
                        cache: 'no-cache',
                        body: JSON.stringify(params),
                        headers: headerJson,
                        credentials: 'include',
                        signal
                    }).then(response => response.json()).then(res => {
                        if (res.data) {
                            this.getTaskMenuResourceStatus()
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
                })
            }
        }
        this.setState({
            folderList: info.fileList,
            progress: info.file.percent && info.file.percent,
            zipProgress
        })
    }

    //查询是否解压完成
    getTaskMenuResourceStatus = () => {
        Actions.getTaskMenuResourceStatus({ taskId: this.state.taskId }, (res) => {
            if (!res) {
                window.cancelGetResourceStatus = setTimeout(() => {
                    this.getTaskMenuResourceStatus();
                }, 500)
            } else {
                this.initData('update');
                this.setState({
                    zipProgress: 'compressComplete'
                })
            }
        })
    }

    //上传压缩包前添加上传提示，限制非zip格式的上传
    handleBeforeUploadZip = (file, fileList) => {
       // const upload = file.type === "application/zip" ? true : false;
       let fileName = file.name.split('.');
       let upload = fileName[fileName.length-1].toUpperCase();
       upload = upload === 'ZIP' ? true : false;
       if(!upload){
        message.error('目前只支持上传zip格式压缩包！');
       }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    }

    //非分片上传 图片 onChange事件
    handleNotChunk = (info) => {
        info.fileList = info.fileList.map(item => {
            if (item.uid === info.file.uid) {
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.storageFile && info.file.response.storageFile.suffix;
                item.url = info.file.response && info.file.response.storageFile && info.file.response.storageFile.path;
                item.name = info.file.response && info.file.response.storageFile && info.file.response.storageFile.name;
                item.type = this.state.fileType === 2 ? "picture" : this.state.fileType === 3 ? 'video' : 'attachment';
                item.isChunk = false;
                item.status = info.file.status;
                item.resourceId = info.file.response && info.file.response.storageFile && info.file.response.storageFile.resourceId;
            }
            return item;
        });
        if (info.file.status === "done") {
            let params = {
                name: info.file.response.storageFile.name,
                ext: info.file.response.storageFile.suffix,
                path: info.file.response.storageFile.path,
                size: info.file.size,
                imageWidth: info.file.response.storageFile.width,
                imageHeight: info.file.response.storageFile.height,
                interviewId: this.state.taskId,
                type: 2,
                taskMenuId: this.state.menuId,
                md5:info.file.response.storageFile.md5,
            };
            Actions.pictureConvertParams(params, (res) => {
                //未处理 删除的时候文件是的时候没有resourceId 导致删除了目录
                let newFileList = info.fileList.map(item => {
                    if (item.uid === info.file.uid) {
                        item.resourceId = res.resourceId;
                    }
                    return item;
                });
                this.setState({ fileList: newFileList });
            });
        }

        this.setState({
            fileList: info.fileList
        })
    }

    //移除资源
    handleRemovePicture = file => {
        //还需要删除当前图片与任务的关系
        let _this = this;
        let Tips="确定删除此文件吗？";
        if(file.type==='folder'){
            Tips="确定删除此文件夹及其子文件吗？"
        }
        confirm({
            title: Tips,
            onOk() {
                let params = { taskMenuId: file.id, type: _this.state.fileType, taskId: _this.state.taskId }
                if (file.type !== 'folder') {
                    params.resourceId = file.resourceId;
                    params.taskMenuId = _this.state.menuId;
                }
                Actions.delResource(params, (res) => {
                    let fileList = _this.state.fileList.filter((item) => {
                        return item.uid !== file.uid
                    });
                    _this.setState(() => {
                        return {
                            fileList
                        }
                    }, () => {
                        _this.initData('update');
                    })
                })
            },
            onCancel() {
              console.log('Cancel');
            },
          });
       
    };

    //预览
    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        if (file.type === 'video'){
            file.url = file.path
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    //上传文件  视频、压缩包需要分片上传
    handleChunk = info => {
        info.fileList = info.fileList.map(item => {
            if (item.uid === info.file.uid) {
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.storageFile && info.file.response.storageFile.suffix;
                item.url = info.file.response && info.file.response.storageFile && info.file.response.storageFile.path;
                item.path = info.file.response && info.file.response.storageFile && info.file.response.storageFile.path;
                item.name = info.file.response && info.file.response.storageFile && info.file.response.storageFile.name;
                item.type = this.state.fileType === 2 ? "picture" : this.state.fileType === 3 ? 'video' : 'attachment';
                item.isChunk = true;
                item.status = info.file.status;
                item.percent = info.file.percent && info.file.percent
                item.duration = info.file.response && info.file.response.storageFile && info.file.response.storageFile.duration;
            }
            return item;
        });
        if (info.file.status === 'done') {
            let params = {
                name: info.file.response.storageFile.name,
                ext: info.file.response.storageFile.suffix,
                path: info.file.response.storageFile.path,
                size: info.file.size,
                interviewId: this.state.taskId,
                taskMenuId: this.state.menuId,
                md5:info.file.response.storageFile.md5,
            };
            if (this.state.fileType === 3) {
                params.duration = info.file.duration
            }
            // 美工附件：根据文件类型选择调用接口
            if(this.state.fileType === 4 && PIC_TYPE.includes(params.ext)) {
                console.log('美工附件--------图片组件启用');
                params = {
                    ...params,
                    imageWidth: info.file.response.storageFile.width,
                    imageHeight: info.file.response.storageFile.height,
                    type: 2,
                };
                Actions.pictureConvertParams(params, (res) => {
                    //未处理 删除的时候文件是的时候没有resourceId 导致删除了目录
                    let newFileList = info.fileList.map(item => {
                        if (item.uid === info.file.uid) {
                            item.resourceId = res.resourceId;
                        }
                        return item;
                    });
                    this.setState({fileList: newFileList});
                });

            } else if (this.state.fileType === 4 && VIDEO_TYPE.includes(params.ext)) {
                console.log('美工附件--------视频组件启用');
                params = {
                    ...params,
                    duration: info.file.duration,
                };
                Actions.videoConvertParams(params,(res) => {
                    this.checkStatus(info.file.response.storageFile.md5, (stateStr) => {
                        let newFileList = info.fileList.map(item => {
                            if (item.uid === info.file.uid) {
                                item.resourceId = res.resourceId;
                                item.ingStatus = stateStr;
                                item.url = item.response ? item.response.url : '';
                                item.path = item.response ? item.response.url : '';
                                item.url = ""
                            }
                            return item;
                        });
                        this.setState({ fileList: newFileList });}, () => {
                        let newFileList = info.fileList.map(item => {
                            if (item.uid === info.file.uid) {
                                item.resourceId = res.resourceId;
                                item.url = res.path;
                            }
                            return item;
                        });
                        this.setState({ fileList: newFileList });
                    });
                })
            } else if (this.state.fileType === 4 && AUDIO_TYPE.includes(params.ext)) {
                console.log('美工附件--------音频组件启用');
                params = {
                    ...params,
                    duration: info.file.duration,
                };
                Actions.audioConvertParams(params,(res) => {
                    this.checkStatus(info.file.response.storageFile.md5, (stateStr) => {
                        let newFileList = info.fileList.map(item => {
                            if (item.uid === info.file.uid) {
                                item.resourceId = res.resourceId;
                                item.ingStatus = stateStr;
                                item.url = item.response ? item.response.url : '';
                                item.path = item.response ? item.response.url : '';
                                item.url = ""
                            }
                            return item;
                        });
                        this.setState({ fileList: newFileList });}, () => {
                        let newFileList = info.fileList.map(item => {
                            if (item.uid === info.file.uid) {
                                item.resourceId = res.resourceId;
                                item.url = res.path;
                            }
                            return item;
                        });
                        console.log(newFileList)
                        this.setState({ fileList: newFileList });
                    });
                })
            } else {
                console.log('美工附件--------其他组件启用');
               let saveName = this.state.fileType === 3 ? Actions.videoConvertParams : Actions.otherFileConvertParams;
               saveName(params, (res) => {
                   this.checkStatus(info.file.response.storageFile.md5, (stateStr) => {
                       let newFileList = info.fileList.map(item => {
                           if (item.uid === info.file.uid) {
                               item.resourceId = res.resourceId;
                               item.ingStatus = stateStr;
                               item.url = item.response ? item.response.url : '';
                               item.path = item.response ? item.response.url : '';
                               item.url = ""
                           }
                           return item;
                       });
                       this.setState({ fileList: newFileList });}, () => {
                       let newFileList = info.fileList.map(item => {
                           if (item.uid === info.file.uid) {
                               item.resourceId = res.resourceId;
                               item.url = res.path;
                           }
                           return item;
                       });
                       this.setState({ fileList: newFileList });
                   });
               });
            }
        }
        this.setState({
            fileList: info.fileList
        })
    }

    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack) {
        setTimeout(() => {
            checkFileStatus(md5).then(res => {
                if (res.state !== "mergeComplete") {
                    this.checkStatus(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack();
            });
        }, 100);//每隔一秒钟进行检查一次
    }
    /**
 * 是否有上传的权限
 * @param newsActivity
 * @param currentUser
 * @returns {boolean}
 */
    isHaveUploadAuth = (newsActivity, currentUser) => {
        console.log(newsActivity)
        let auth = false;
        //任务状态 4是已完成，<4, 3 是已提交  这块需求来回变动。
        if (newsActivity && currentUser && (newsActivity.status < 4)) {
            //查看当前的记者有哪些角色//指挥调度任务
            if (newsActivity.interviewJointers) {
                newsActivity.interviewJointers.map(jointer => {
                    if(typeof jointer==="number" ){
                        auth = true;
                        return
                    }
                    if (jointer.account === currentUser.account) {
                        //判断是否已经领取了
                        let currentInterviewRole=this.props.fileType;//2美工，3//视频，4//附件
                        //已发布之前都是有按钮，已发布status 是状态4
                        if ((jointer.status < 4) && (jointer.interviewRole === currentInterviewRole)) {//是摄像记者并且已领取才显示
                            auth = true;
                        }
                    }
                });
            }else{
                //如果不存在就是 图片池，视频池，附件池
                auth = true;
            }
        }
        return auth;
    };


    render() {
        const { treeData, fileList, expendKeys, breadCrumb, selectedKeys, previewVisible, previewImage } = this.state;
        let showUploadButton = this.props.currentUser ? this.isHaveUploadAuth(this.props.data, this.props.currentUser) : true;
        return (
            <React.Fragment>
                <div className="task-upload">
                    <div className="left">
                        <Scrollbars style={{ height: 550, width: '100%' }}>
                            <Tree
                                showLine={true}
                                onSelect={this.selectTreeNode}
                                expandedKeys={expendKeys}
                                selectedKeys={selectedKeys}
                                onExpand={this.changeExpend}
                            >
                                {this.renderTreeContent(treeData)}
                            </Tree>
                        </Scrollbars>
                    </div>
                    <div className="right">
                        <div className="conditions">
                            <div className="breadcrumb">
                                <Breadcrumb>
                                    {
                                        breadCrumb && breadCrumb.length > 0 ?
                                            breadCrumb.map((item, index) => (
                                                <Breadcrumb.Item style={{ cursor: 'pointer' }} key={item.id} onClick={() => this.clickFolder(item.id)}>{item.name}</Breadcrumb.Item>
                                            )) : null
                                    }
                                </Breadcrumb>
                            </div>

                        </div>
                        <div className="content" style={{ height: showUploadButton ? 'calc( 100% - 60px )' : 'calc( 100% - 30px )' }}>
                            <Scrollbars>
                                <UploadWallPackage
                                    listType="picture-card"
                                    fileList={fileList}
                                    icons={this.props.icons}
                                    onRemove={this.handleRemovePicture}
                                    onDoubleClick={this.clickFolder}
                                    onPreview={this.handlePreview}
                                    onPlay={this.handlePreview}
                                />
                            </Scrollbars>
                        </div>
                        {
                            showUploadButton ?
                                <div className="bottom">
                                    <div className="upload">
                                        {this.renderUpload()}
                                    </div>
                                </div> : null
                        }

                    </div>
                </div>
                <Modal
                    visible={previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}>
                    {
                        this.state.fileType === 2 ? <img alt="example" style={{ width: '100%' }} src={previewImage} /> : <video controls={"controls"} style={{ width: '100%' }} src={previewImage} />
                    }
                </Modal>
            </React.Fragment>
        )
    }
}

TaskUpload.defaultProps = {
    fileType: 2, //定义文件类型：  图片池、视频池、附件池,
    icons: ["eye", "download","play", "delete"], //定义对文件的操作,
    taskId: 1,
}

TaskUpload.propTypes = {
    fileType: PropTypes.number.isRequired,
    icons: PropTypes.array.isRequired,
    taskId: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.systemReducer.currentUser,
        config: state.systemReducer.config
    }
}

export default connect(mapStateToProps, null)(TaskUpload);

